import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import * as config from '@config';
import { addMessage, MsgLevel } from '@features/messages/messagesSlice';
import { GetToken } from '../../utils/storage';

const initialState = {
    data: [],
    fetching: false,
    fetched: false,
    error: '',
};

// fetch trips
export const fetchTrips = createAsyncThunk('trips/fetch', async (searchParams, thunkAPI) => {
    const url = new URL(`${config.apiURL}/trips`);
    try {
        const resp = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${GetToken()}`,
            },
        });
        return resp.data;
    } catch (error) {
        const msg = error.response?.data?.error || 'Something went wrong with fetchTrips';
        thunkAPI.dispatch(
            addMessage({
                type: MsgLevel.Error,
                content: msg,
            })
        );
        return thunkAPI.rejectWithValue(msg);
    }
});

const tripsSlice = createSlice({
    name: 'trips',
    initialState,
    reducers: {
        cleanupTrips: (state) => {
            console.log('cleanup trips');
            state = initialState;
            return state;
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(fetchTrips.pending, (state, action) => {
                state.fetching = true;
            })
            .addCase(fetchTrips.fulfilled, (state, action) => {
                const trips = action.payload.trips;
                state.fetched = true;
                state.fetching = false;
                state.data = trips;
            })
            .addCase(fetchTrips.rejected, (state, action) => {
                state = { ...initialState };
                state.error = action.payload;
                console.log(action);
            });
    },
});

export const { cleanupTrips } = tripsSlice.actions;

export default tripsSlice.reducer;
